var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0"},[(_vm.rol_actual=='ADMIN')?_c('VistaRegion'):_c('VistaPais')],1)}
var staticRenderFns = []

export { render, staticRenderFns }